import React from "react";
export var Arrow = _ref => {
  var {
    expanded
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-heading-dropdown-arrow gray"
  }, /*#__PURE__*/React.createElement("path", {
    d: expanded ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
  }));
};
//# sourceMappingURL=arrow.js.map